import { render, staticRenderFns } from "./EmailVerificationForm.vue?vue&type=template&id=3c1737b6&scoped=true"
import script from "./EmailVerificationForm.vue?vue&type=script&lang=js"
export * from "./EmailVerificationForm.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationForm.vue?vue&type=style&index=0&id=3c1737b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1737b6",
  null
  
)

export default component.exports